import { useEffect, useState } from "react";
import MicroModal from 'micromodal'
import Modal from '../../components/common/modal/Modal'

const Card = ({data, addToCart}) => {
    MicroModal.init()

    const getSeatPrice = ( seatDiscountInfos, currentQuantity, currentPrice ) => {

        let quantity = 0
        let newPrice = 0
        seatDiscountInfos.forEach(seatDiscount => {
            if ( currentQuantity >= seatDiscount.total_team_seats && seatDiscount.total_team_seats >= quantity ) {
                quantity = seatDiscount.total_team_seats
                if ( seatDiscount.discount_type === 'fixed' ) {
                    newPrice = parseInt(currentPrice) - parseInt(seatDiscount.discount_per_seat)
                } else {
                    newPrice = parseInt(currentPrice) * ( ( 100 - parseInt(seatDiscount.discount_per_seat) ) / 100 )
                }
            }
        })
    
        if ( newPrice !== 0 ) currentPrice = newPrice
        return currentPrice
    }

    return (
        <>
          {
            data.map((product, index) => {
                
                const modalID = "msync-org-shop-product-" + product.id
                const [quantity, setQuantity] = useState(1)
                const [price, setPrice] = useState(product.price)
                const [variationQuantity, setVariationQuantity] = useState(0)
                const [currentVariationID, setCurrentVariationID] = useState(0)
                const [productAdditionalSeats, setProductAdditionalSeats] = useState(false)
                const [variationAddMore, setVariationAddMore] = useState(false)
                const [totalPrice, setTotalPrice] = useState(0)
                const [isLoading, setIsLoading] = useState(false)

                useEffect(() => {
                    if ( currentVariationID === 0 ) return

                    const currentVariation = (product.variations).filter(variation => Object.keys(variation).some(key => variation[key] === currentVariationID));
                    if ( currentVariation.length === 0 ) return
                    setVariationQuantity( currentVariation[0].plan.total )
                    setVariationAddMore( currentVariation[0].plan.additional_seat )
                    let total = currentVariation[0].plan.total
                    let additionalQuantity = quantity > 0 && productAdditionalSeats && currentVariation[0].plan.additional_seat ? quantity : 0
                    total = parseInt(total) + parseInt(additionalQuantity)
                    let currentPrice = getSeatPrice( product.seat_discount, total, product.price )
                    setTotalPrice( total * currentPrice )
                    setPrice(currentPrice)
                }, [currentVariationID])

                useEffect(() => {
                    if ( product.type === 'simple' ) {
                        let currentPrice = price
                        if ( product.isProductTeam ) {
                            currentPrice = getSeatPrice( product.seat_discount, quantity, product.price )
                            setPrice( currentPrice )
                        }
                        let currentTotalPrice = totalPrice
                        currentTotalPrice = parseInt( quantity * currentPrice )
                        setTotalPrice( currentTotalPrice )
                    } else {
                        if ( !productAdditionalSeats ) {
                            let currentPrice = getSeatPrice( product.seat_discount, variationQuantity, product.price )
                            const currentTotalPrice = parseInt(variationQuantity) * currentPrice 
                            setTotalPrice( currentTotalPrice )
                            setPrice( currentPrice )
                        } else {
                            let additionalQuantity = quantity > 0 ? quantity : 0
                            let maxQuantity = ( parseInt(variationQuantity) + parseInt(additionalQuantity) )
                            let currentPrice = getSeatPrice( product.seat_discount, maxQuantity, product.price )
                            const currentTotalPrice = maxQuantity * currentPrice 
                            setTotalPrice( currentTotalPrice )
                            setPrice( currentPrice )
                        }
                    }
                }, [quantity, productAdditionalSeats])

                useEffect(() => {
                    if ( !isLoading ) return
                    let success = addToCart(quantity, product.id, product.type, variationQuantity, currentVariationID, variationAddMore)
                    // console.log('loading');
                    if ( success ) setIsLoading(false)
                }, [isLoading])

                return (
                    <div class='membersync-orgs-products-card'>
                        <div>
                            <div class='membersync-orgs-product-featured-image-container'>
                                <img src={product.image} alt="Product Featured Image" class="membersync-orgs-product-featured-image" />
                            </div>
                        </div>
                        <div class="membersync-orgs-product-infos-container">
                            <div class='membersync-orgs-product-name'>{product.name}</div>
                            <div class='membersync-orgs-see-product'>
                                <Modal classNames="membersync-orgs-see-product-button" modalId={modalID} buttonTitle="See more">
                                    <header className="modal__header membersync-orgs-product-title">
                                        <h2 className="modal__title">{ product.name }</h2>
                                        <button type='button' className="modal__close" aria-label="Close" onClick={()=>MicroModal.close(modalID)}></button>
                                    </header>
                                    <main className="modal__content">
                                        <div class='membersync-orgs-product-modal-infos-container'>
                                            <div class='membersync-orgs-product-modal-featured-image-container'>
                                                <img src={product.image} alt="Product Featured Image" class="membersync-orgs-product-featured-image" />
                                            </div>
                                            <div class='membersync-orgs-product-modal-extra-infos-container'>
                                                <div class='membersync-orgs-product-modal-variations'>
                                                    {
                                                        product.isProductTeam ? 
                                                            (product.variations).map((variation) => {
                                                                return ( <input type="button" 
                                                                    value={variation.name} 
                                                                    class="membersync-orgs-product-variations-button"
                                                                    onClick={() => {
                                                                        // console.log('variation_id : ', variation)
                                                                        setCurrentVariationID( variation.id )
                                                                    }} /> 
                                                                )
                                                            }) 
                                                        :
                                                        ''
                                                    }
                                                </div>
                                                <div class='membersync-orgs-product-modal-price'>
                                                    { price + ' ' + product.currency } { product.isProductTeam ? ' / seat' : '/ License' }
                                                </div>
                                                <div class='membersync-orgs-product-modal-variation-add-more'>
                                                    { variationAddMore ? 
                                                        <div>
                                                            <label for="msync-organization-shop-add-more">Add additional seats</label> 
                                                            <input type="checkbox" name="msync-organization-shop-add-more" checked={productAdditionalSeats}
                                                                onClick={(e) => {
                                                                    setProductAdditionalSeats( e.target.checked )
                                                                }}
                                                            />
                                                        </div> 
                                                        : '' }
                                                </div>
                                                <div class='membersync-orgs-product-modal-quantity'>
                                                    <div>
                                                        { product.type === 'simple' || ( productAdditionalSeats && variationAddMore ) ? <input id="msync-org-shop-product-quantity" type="number" min="1"
                                                            value={quantity}
                                                            onChange={(e) => {
                                                                setQuantity(e.target.value)
                                                            }}
                                                        /> : '' }
                                                    </div>
                                                    <div>
                                                        { product.type !== 'simple' ? 
                                                            ( productAdditionalSeats && variationAddMore ? 'Quantity : ' + variationQuantity + ' + ' + quantity + ' Additional seats.' 
                                                                : 'Quantity : ' + variationQuantity ) 
                                                            : '' }
                                                    </div>
                                                </div>
                                                <div class='membersync-orgs-product-modal-total'>
                                                    Total : { totalPrice + ' ' + product.currency }
                                                </div>
                                            </div>
                                        </div>
                                        <div class='membersync-orgs-product-modal-description'>
                                            { product.description }
                                        </div>
                                        <div class='membersync-orgs-product-modal-buttons'>
                                            <input type="button" value={ isLoading ? "Loading ..." : "Add to cart"} onClick={() => {
                                                setIsLoading(true)
                                            }} disabled={isLoading} class='membersync-orgs-product-modal-add-button' />
                                            <input type="button" onClick={() => {
                                                MicroModal.close(modalID)
                                            }} value="Close" class='membersync-orgs-product-modal-close-button' />
                                        </div>
                                    </main>
                                </Modal>
                            </div>
                        </div>
                    </div>
                )
            })
          }  
        </>
    );
};

export default Card;